module.exports = __webpack_public_path__ + "img/black_board_banner_bg_1.918bfd9b.png";